import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';

const SignInPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #FA9940 0%, #4A60F4 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: 1, sm: 2 },
      }}
    >
      <Container maxWidth="sm" sx={{ width: '100%', px: { xs: 1, sm: 2 } }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Card
            elevation={24}
            sx={{
              borderRadius: 4,
              overflow: 'hidden',
              bgcolor: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(20px)',
            }}
          >
            <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
              {/* Header */}
              <Box sx={{ textAlign: 'center', mb: { xs: 2, sm: 3, md: 4 } }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
                    background: 'linear-gradient(135deg, #FA9940 0%, #4A60F4 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    mb: { xs: 1, sm: 2 },
                  }}
                >
                  Autobia
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: '1.1rem', sm: '1.25rem' },
                    color: 'text.primary',
                    mb: { xs: 0.5, sm: 1 },
                  }}
                >
                  Design System
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: 'text.secondary',
                    fontSize: { xs: '0.875rem', sm: '1rem' },
                    maxWidth: '400px',
                    mx: 'auto',
                    px: { xs: 1, sm: 0 },
                  }}
                >
                  Sign in with your @autobia.sa account to access our comprehensive design system documentation
                </Typography>
              </Box>

              {/* Clerk Sign In Component */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  '& .cl-rootBox': {
                    width: '100%',
                  },
                  '& .cl-card': {
                    boxShadow: 'none',
                    border: 'none',
                  },
                }}
              >
                <SignIn
                  routing="path"
                  path="/sign-in"
                  redirectUrl="/dashboard"
                  signUpUrl="/sign-up"
                />
              </Box>

              {/* Footer */}
              <Box sx={{ textAlign: 'center', mt: { xs: 2, sm: 3, md: 4 } }}>
                <Typography variant="caption" color="text.secondary">
                  Access restricted to @autobia.sa employees only
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </motion.div>
      </Container>
    </Box>
  );
};

export default SignInPage;